import styled from 'styled-components';
import { SubH, H3, SmallP } from '../../style/typography';
import { colors } from '../../style/colors';
import { MarginContainer } from '../../lib/shared';
import { min } from '../../lib/responsive';

const InfoRowContainer = styled(MarginContainer)`
  display: block;
  padding: ${props => (props.sameTime ? '0 0 4.5rem 0' : '3rem 0 4.5rem 0')};
  margin-top: ${props => (props.sameTime ? '-2rem' : '0')};
  @media ${min.desktop} {
    display: flex;
  }
`;

const InfoRowDescription = styled(SmallP)`
  color: ${props => (props.isInPerson ? colors.BLACK : colors.WHITE)};
  width: 100%;
  margin: 0;
  @media ${min.desktop} {
    width: 31rem;
  }
  @media ${min.desktopMidLg} {
    width: 50%;
  }
`;

const InfoRowTime = styled(SubH)`
  color: ${props => (props.isInPerson ? colors.BLACK : colors.WHITE)};
  width: 100%;
  @media ${min.desktop} {
    width: 6rem;
  }
`;

const InfoRowTitle = styled(H3)`
  color: ${props => (props.isInPerson ? colors.BLACK : colors.WHITE)};
  margin: 0;
  font-size: 3.1rem;
  width: 100%;
  font-size: clamp(1.5em, 10vw, 2.5em);
  line-height: 1em;
  padding-top: 0.6rem;
  @media ${min.tablet} {
    font-size: 3.1rem;
  }
  @media ${min.desktop} {
    width: 18rem;
  }
`;

const SpeakerDetailsContainer = styled.div`
  display: block;
  padding-bottom: 0.5rem;
  @media ${min.desktop} {
    padding-left: 2rem;
    padding-right: 3rem;
    width: 25rem;
  }
`;

const TitleTagContainer = styled.div`
  display: block;
`;

export {
  InfoRowContainer,
  InfoRowDescription,
  InfoRowTime,
  InfoRowTitle,
  SpeakerDetailsContainer,
  TitleTagContainer,
};
